export default "__VITE_ASSET__Bl$SvU$y__"